import { headerHeight, zIndexToolbar, toolbarHeight } from 'crazyEditor/core/globals';
import * as Colors from 'material-ui/styles/colors';
import firstRenderAnimationStyles from '../common/firstRenderAnimationStyles';

export default {
  container: {
    position: 'fixed',
    width: '100%',
    top: 0,
    zIndex: zIndexToolbar,
    height: headerHeight,
    backgroundColor: Colors.grey50,
    boxSizing: 'border-box',
    boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
    borderRadius: '2px',
  },
  previewMode: {
    backgroundColor: 'transparent',
    borderBottomColor: 'transparent',
    height: toolbarHeight
  }
};
